import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
} from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enGB } from "date-fns/locale";

export default function EventModal({ open, onClose, onSave, selectedDate }) {
  const [title, setTitle] = useState("");
  const [start, setStart] = useState(new Date());
  const [end, setEnd] = useState(new Date());
  const [notes, setNotes] = useState("");
  const [color, setColor] = useState("#1976d2");

  // ✅ Reset when modal opens
  useEffect(() => {
    if (open) {
      const base =
        selectedDate instanceof Date && !isNaN(selectedDate)
          ? selectedDate
          : new Date();

      setTitle("");
      setStart(base);
      setEnd(new Date(base.getTime() + 60 * 60 * 1000));
      setNotes("");
      setColor("#1976d2");
    }
  }, [open, selectedDate]);

  const handleSave = () => {
    if (!title.trim()) {
      alert("Please enter a title");
      return;
    }

    const startDate = start instanceof Date ? start : new Date(start);
    const endDate = end instanceof Date ? end : new Date(end);

    if (isNaN(startDate) || isNaN(endDate)) {
      alert("Invalid date selected");
      return;
    }

    if (endDate <= startDate) {
      alert("End time must be after start time");
      return;
    }

    // ✅ SEND DATE OBJECTS ONLY
    onSave({
      title,
      start: startDate,
      end: endDate,
      notes,
      color,
    });

    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Add New Event</DialogTitle>

      <DialogContent dividers>
        <TextField
          fullWidth
          margin="normal"
          label="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />

        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
          <DateTimePicker
            label="Start Date & Time"
            value={start}
            onChange={(value) => value && setStart(new Date(value))}
            renderInput={(params) => (
              <TextField fullWidth margin="normal" {...params} />
            )}
          />

          <DateTimePicker
            label="End Date & Time"
            value={end}
            onChange={(value) => value && setEnd(new Date(value))}
            renderInput={(params) => (
              <TextField fullWidth margin="normal" {...params} />
            )}
          />
        </LocalizationProvider>

        <TextField
          fullWidth
          margin="normal"
          label="Notes"
          multiline
          rows={3}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />

        <TextField
          select
          fullWidth
          margin="normal"
          label="Event Color"
          value={color}
          onChange={(e) => setColor(e.target.value)}
        >
          <MenuItem value="#1976d2">Blue</MenuItem>
          <MenuItem value="#388e3c">Green</MenuItem>
          <MenuItem value="#d32f2f">Red</MenuItem>
          <MenuItem value="#fbc02d">Yellow</MenuItem>
        </TextField>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
